module.exports = __webpack_public_path__ + "img/blockhype.016563de.png";